(function () {
  // Update the cart count in the top bar and in the menu
  function setCount(n) {
    var cart = document.querySelector('.cd-cart');
    if (cart) {
      var c = cart.querySelector('.cd-cart__count');
      if (!c && n > 0) {
        c = document.createElement('span');
        c.className = 'cd-cart__count';
        cart.appendChild(c);
      }
      if (c) { if (n > 0) c.textContent = n; else c.remove(); }
      cart.setAttribute('aria-label', 'Cart, ' + n + ' items');
    }
    var d = document.querySelector('.cd-drawer__cart');
    if (d) d.textContent = 'Cart (' + n + ')';
  }

  // Photo slideshow with thumbnails
  function gallery(root) {
    var track = root.querySelector('.dd-pp__track');
    if (!track) return;
    var thumbs = [].slice.call(root.querySelectorAll('.dd-pp__thumb'));
    var prev = root.querySelector('.dd-pp__arrow--prev');
    var next = root.querySelector('.dd-pp__arrow--next');
    var total = track.children.length;

    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }

    function go(i) {
      i = Math.max(0, Math.min(total - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function sync() {
      var i = index();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (prev) prev.classList.toggle('is-hidden', i <= 0);
      if (next) next.classList.toggle('is-hidden', i >= total - 1);
      var a = thumbs[i];
      if (a && a.parentNode && a.parentNode.scrollWidth > a.parentNode.clientWidth) {
        a.parentNode.scrollTo({ left: a.offsetLeft - 12, behavior: 'smooth' });
      }
    }

    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  // Size dropdown, price and add to cart
  function buy(root) {
    var dataEl = root.querySelector('.dd-pp__data');
    var btn = root.querySelector('.dd-pp__add');
    if (!dataEl || !btn) return;

    var variants = JSON.parse(dataEl.textContent);
    var selects = [].slice.call(root.querySelectorAll('.dd-opt'));
    var priceEl = root.querySelector('.dd-pp__now');
    var wasEl = root.querySelector('.dd-pp__was');
    var msg = root.querySelector('.dd-pp__msg');
    var restock = root.getAttribute('data-restock') === 'true';
    var current = null;
    var busy = false;

    selects.forEach(function (s) {
      [].forEach.call(s.options, function (o) { o.setAttribute('data-base', o.textContent); });
    });

    function values() { return selects.map(function (s) { return s.value; }); }

    function find(vals) {
      if (!selects.length) return variants[0];
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      })[0] || null;
    }

    // Sold out sizes stay in the list, greyed out and marked
    function marks() {
      var vals = values();
      selects.forEach(function (s, i) {
        [].forEach.call(s.options, function (o) {
          var ok = variants.some(function (v) {
            return v.available && v.options[i] === o.value &&
              v.options.every(function (x, j) { return j === i || x === vals[j]; });
          });
          o.disabled = !ok && o.value !== s.value;
          o.textContent = o.getAttribute('data-base') + (ok ? '' : '  (sold out)');
        });
      });
    }

    function update() {
      marks();
      current = find(values());
      if (current) {
        if (priceEl) priceEl.textContent = current.price;
        if (wasEl) {
          if (current.compare) { wasEl.textContent = current.compare; wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      }
      btn.classList.remove('is-restock');
      if (!current) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      else if (current.available) { btn.disabled = false; btn.textContent = 'Add to cart'; }
      else if (restock) { btn.disabled = true; btn.classList.add('is-restock'); btn.textContent = 'Restocking soon..'; }
      else { btn.disabled = true; btn.textContent = 'Sold out'; }
    }

    btn.addEventListener('click', function () {
      if (busy || !current || !current.available) return;
      busy = true;
      msg.textContent = '';
      btn.disabled = true;
      btn.textContent = 'Adding..';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'Could not add to cart');
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (c) {
              setCount(c.item_count);
              btn.textContent = 'Added';
              return new Promise(function (done) { setTimeout(done, 1600); });
            });
        })
        .catch(function (e) { msg.textContent = e.message; })
        .then(function () { busy = false; update(); });
    });

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  function init() {
    document.querySelectorAll('.dd-pp').forEach(function (root) {
      if (root.__ddInit) return;
      root.__ddInit = true;
      gallery(root);
      buy(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();